import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTWCL_Go_to_slide_N0 } from './Pagination.messages.json';
import styles from './Pagination.scss';

interface PaginationProps {
  slidesCount: number;
  currentSlide: number;
  goToSlide: (index: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ slidesCount, currentSlide, goToSlide }) => {
  const { formatMessage } = useRegulatoryIntl();

  if (slidesCount === 1) {
    return null;
  }

  return (
    <div className={styles.paginationWrapper}>
      <ul className={styles.pagination}>
        {Array.from({ length: slidesCount }).map((_, index) => (
          <li
            key={index}
            className={index === currentSlide ? styles.activeDot : styles.inactiveDot}
            onClick={() => goToSlide(index)}
            aria-label={formatMessage(TXTWCL_Go_to_slide_N0, { slideNumber: index + 1 })}
          />
        ))}
      </ul>
    </div>
  );
};

export default Pagination;
